<template>
  <base-slide-over ref="slideOver" :title="title" size="xl">
    <base-field class="tw-mt-4 tw-ml-6" title="Prescription Program" :value="programName" />
    <base-form ref="form" class="tw-py-2.5 tw-px-4 sm:tw-py-4 sm:tw-px-6" v-model="isFormValid">
      <base-select
        class="tw-mt-3"
        label="Plan"
        placeholder="Select plan"
        :optgroups="planOptGroups"
        v-model="selectedPlanId"
        label-key="name"
        value-key="businessPlanId"
        required
      />
    </base-form>
    <template #fixed-bottom>
      <div class="tw-py-2 tw-px-3 tw-flex tw-justify-end">
        <base-button type="flat" @click="$refs.slideOver.hide()" class="tw-mr-3">Cancel</base-button>
        <base-button @click="inviteToPlan" :disabled="!isFormValid" :loading="isInviting">Invite</base-button>
      </div>
    </template>
  </base-slide-over>
</template>

<script>
import { mapGetters } from "vuex";
import { capitalize, uniq, orderBy } from "lodash";

export default {
  props: {
    businessId: String,
    userId: String,
  },
  data() {
    return {
      isFormValid: true,
      isInviting: false,
      isLoadingPlans: false,
      isLoadingMapping: false,
      plans: [],
      selectedPlanId: null,
      prescriptionId: null,
      programName: null,
    };
  },
  computed: {
    ...mapGetters("organization", ["organization"]),
    title() {
      return `Invite ${capitalize(this.organization.customerLabelSingular)} to Plan`;
    },
    planGroups() {
      return this.plans ? uniq(this.plans.map(({ planGroup }) => planGroup)).sort() : [""];
    },
    planOptGroups() {
      const planOptGroups = [];

      this.planGroups.forEach((pg) => {
        planOptGroups.push({
          label: pg,
          options: orderBy(this.plans.filter((p) => p.planGroup === pg), ["name"]),
        });
      });

      return planOptGroups;
    },
  },
  created() {
    this.getPlans();
  },
  methods: {
    show(prescription) {
      this.prescriptionId = prescription.id;
      this.programName = prescription.businessProgram.name;

      this.getMapping();
      this.$refs.slideOver.show();
      this.$refs.form.reset();
    },
    hide() {
      this.$refs.slideOver.hide();
    },
    async getPlans() {
      try {
        this.isLoadingPlans = true;
        const response = await this.$axios.get(`/businesses/${this.businessId}/plans/list`);
        this.plans = response.data;
      } catch (error) {
        this.EventBus.$emit("GLOBAL_ERROR", {
          title: "Unable to retrieve plans",
          message: "We were not able to retrieve the your business plans. There may have been a connection error. Please reload the page to try again.",
          error,
        });
      } finally {
        this.isLoadingPlans = false;
      }
    },
    async inviteToPlan() {
      try {
        this.isInviting = true;
        await this.$axios.post(`/businesses/${this.businessId}/prescriptions/${this.prescriptionId}/invite`, {
          businessPlanIds: [this.selectedPlanId],
        });
        this.hide();
        this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Invite Sent Successfully", message: "Invite was sent successfully" });
      } catch (error) {
        this.EventBus.$emit("GLOBAL_ERROR", {
          title: "Failed to invite",
          message: "We were not able to invite " + this.fullName + ". Please try again.",
          error,
        });
      } finally {
        this.isInviting = false;
      }
    },
    async getMapping() {
      try {
        this.isLoadingMapping = true;
        const response = await this.$axios.get(`/businesses/${this.businessId}/prescriptions/${this.prescriptionId}/mapping`);
        if (response.data) {
          this.selectedPlanId = response.data;
        }
      } finally {
        this.isLoadingMapping = false;
      }
    },
  },
};
</script>
